import { TFunction } from 'i18next';

export const date2MonthDate = (dateObject: Date, t: TFunction<'translation', undefined> | undefined = undefined) => {
  const daysFormat = ['일', '월', '화', '수', '목', '금', '토'];
  const month = dateObject.getMonth() + 1;
  const date = dateObject.getDate();
  const day = t ? t(daysFormat[dateObject.getDay()]) : daysFormat[dateObject.getDay()];

  return `${month}.${date}(${day}) ${t ? t('새벽') : '새벽'} 01시 ~ `;
};
